<script setup>
const certifications = [
  // {
  //   id: 'nuxt',
  //   name: 'Nuxt',
  //   description: 'Get certified for Nuxt 3, the free and open-source framework for creating type-safe, performant and production-grade full-stack web applications and websites with Vue.js.'
  // }
  // {
  //   id: 'react',
  //   name: 'React',
  //   description: 'React is a JavaScript library developed by Facebook that, among other things, was used to build Instagram.com. It aims to allow developers to easily create user interfaces for websites, desktop apps and mobile applications.'
  // },
  {
    id: 'typescript',
    name: 'TypeScript',
    description: 'TypeScript is a strongly typed programming language that builds on JavaScript, giving you better tooling at any scale.'
  }
  /* {
    id: 'tailwind',
    name: 'Tailwind',
    description: 'Tailwind CSS is a popular CSS framework designed to enable developers to create applications faster and easier. Get your Tailwind certification to validate your expertise and skills.'
  } */
]
</script>

<template>
  <AppContainer class="pt-32 md:pt-40">
    <h2 class="heading-primary mx-auto max-w-lg text-center text-3xl font-bold md:text-[54px] md:leading-tight xl:max-w-full">
      <em>Certifications</em> Coming Soon
    </h2>
    <div class="mx-auto mt-10 grid max-w-2xl gap-6 md:mt-20 md:gap-10 xl:max-w-full xl:grid-cols-2 xl:gap-15">
      <HomeUpcomingCertification
        v-for="certification in certifications"
        :key="certification.id"
        v-bind="{ certification }" />
    </div>
  </AppContainer>
</template>
